export const statusCCID = {
  sent: {
    label: "Sent",
    type: "active",
  },
  error: {
    label: "Error",
    type: "danger",
  },
  "not-sent": {
    label: "Not Sent",
    type: "warning",
  },
  "on-progress": {
    label: "On Progress",
    type: "warning",
  },
  "on_progress": {
    label: "On Progress",
    type: "warning",
  },
  default: {
    label: "-",
    type: "default",
  },
};
